import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { LoginPage } from "./modules/auth/LoginPage";
import { DashboardPage } from "./modules/dashboard/DashboardPage";
import { AttributeValuesList } from "./modules/masters/AttributeValuesList";
import { AttributeValuesPage } from "./modules/masters/AttributeValuesPage";
import { AttributesList } from "./modules/masters/AttributesList";
import { AttributesPage } from "./modules/masters/AttributesPage";
import { BrandsList } from "./modules/masters/BrandsList";
import { BrandsPage } from "./modules/masters/BrandsPage";
import { CategoriesList } from "./modules/masters/CategoriesList";
import { CategoriesPage } from "./modules/masters/CategoriesPage";
import { CartsList } from "./modules/masters/CartsList";
import { CitiesList } from "./modules/masters/CitiesList";
import { CouponUsagesPage } from "./modules/masters/CouponUsagesPage";
import { CouponsList } from "./modules/masters/CouponsList";
import { CouponsPage } from "./modules/masters/CouponsPage";
import { CountriesList } from "./modules/masters/CountriesList";
import { CurrenciesList } from "./modules/masters/CurrenciesList";
import { CustomersList } from "./modules/masters/CustomersList";
import { CustomerCartsPage } from "./modules/masters/CustomerCartsPage";
import { CustomerOrdersPage } from "./modules/masters/CustomerOrdersPage";
import { CustomersPage } from "./modules/masters/CustomersPage";
import { CustomerWishlistsPage } from "./modules/masters/CustomerWishlistsPage";
import { DepartmentsList } from "./modules/masters/DepartmentsList";
import { DesignationsList } from "./modules/masters/DesignationsList";
import { EmployeesList } from "./modules/masters/EmployeesList";
import { EmployeesPage } from "./modules/masters/EmployeesPage";
import { NotificationsList } from "./modules/masters/NotificationsList";
import { NotificationsPage } from "./modules/masters/NotificationsPage";
import { OrderDetailsList } from "./modules/masters/OrderDetailsList";
import { OrderDetailsPage } from "./modules/masters/OrderDetailsPage";
import { OrdersList } from "./modules/masters/OrdersList";
import { OrdersPage } from "./modules/masters/OrdersPage";
import { ProductImagesList } from "./modules/masters/ProductImagesList";
import { ProductImagesPage } from "./modules/masters/ProductImagesPage";
import { ProductQuestionsList } from "./modules/masters/ProductQuestionsList";
import { ProductQuestionsPage } from "./modules/masters/ProductQuestionsPage";
import { ProductReviewImagesList } from "./modules/masters/ProductReviewImagesList";
import { ProductReviewImagesPage } from "./modules/masters/ProductReviewImagesPage";
import { ProductReviewsList } from "./modules/masters/ProductReviewsList";
import { ProductReviewsPage } from "./modules/masters/ProductReviewsPage";
import { ProductSpecificationsList } from "./modules/masters/ProductSpecificationsList";
import { ProductSpecificationsPage } from "./modules/masters/ProductSpecificationsPage";
import { ProductTagsList } from "./modules/masters/ProductTagsList";
import { ProductTagsPage } from "./modules/masters/ProductTagsPage";
import { ProductVarientOptionsList } from "./modules/masters/ProductVarientOptionsList";
import { ProductVarientOptionsPage } from "./modules/masters/ProductVarientOptionsPage";
import { ProductVarientsList } from "./modules/masters/ProductVarientsList";
import { ProductVarientsPage } from "./modules/masters/ProductVarientsPage";
import { ProductsPage } from "./modules/masters/ProductsPage";
import { ProductsList } from "./modules/masters/ProductsList";
import { StatesList } from "./modules/masters/StatesList";
import { VendorsList } from "./modules/masters/VendorsList";
import { VendorsPage } from "./modules/masters/VendorsPage";
import { WalletTransactionsList } from "./modules/masters/WalletTransactionsList";
import { WalletTransactionsPage } from "./modules/masters/WalletTransactionsPage";
import { WishlistsList } from "./modules/masters/WishlistsList";
import { CompanySettingsPage } from "./modules/settings/CompanySettingsPage";
import { MyProfilePage } from "./modules/profile/MyProfilePage";
import { AppLayout } from "./layout/AppLayout";
import { RequireAuth } from "./modules/auth/RequireAuth";

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/"
        element={
          <RequireAuth>
            <AppLayout />
          </RequireAuth>
        }
      >
        <Route index element={<DashboardPage />} />
        <Route path="attribute-values-list" element={<AttributeValuesList />} />
        <Route path="attribute-values" element={<AttributeValuesPage />} />
        <Route path="attributes-list" element={<AttributesList />} />
        <Route path="attributes" element={<AttributesPage />} />
        <Route path="brands-list" element={<BrandsList />} />
        <Route path="brands" element={<BrandsPage />} />
        <Route path="carts-list" element={<CartsList />} />
        <Route path="categories-list" element={<CategoriesList />} />
        <Route path="categories" element={<CategoriesPage />} />
        <Route path="cities-list" element={<CitiesList />} />
        <Route path="cities" element={<Navigate to="/cities-list" replace />} />
        <Route path="coupon-usages" element={<CouponUsagesPage />} />
        <Route path="coupons-list" element={<CouponsList />} />
        <Route path="coupons" element={<CouponsPage />} />
        <Route path="countries-list" element={<CountriesList />} />
        <Route path="countries" element={<Navigate to="/countries-list" replace />} />
        <Route path="currencies-list" element={<CurrenciesList />} />
        <Route path="currencies" element={<Navigate to="/currencies-list" replace />} />
        <Route path="customer-carts" element={<CustomerCartsPage />} />
        <Route path="customer-orders" element={<CustomerOrdersPage />} />
        <Route path="customers-list" element={<CustomersList />} />
        <Route path="customers" element={<CustomersPage />} />
        <Route path="customer-wishlists" element={<CustomerWishlistsPage />} />
        <Route path="departments-list" element={<DepartmentsList />} />
        <Route path="departments" element={<Navigate to="/departments-list" replace />} />
        <Route path="designations-list" element={<DesignationsList />} />
        <Route path="designations" element={<Navigate to="/designations-list" replace />} />
        <Route path="employees-list" element={<EmployeesList />} />
        <Route path="employees" element={<EmployeesPage />} />
        <Route path="notifications-list" element={<NotificationsList />} />
        <Route path="notifications" element={<NotificationsPage />} />
        <Route path="order-details-list" element={<OrderDetailsList />} />
        <Route path="order-details" element={<OrderDetailsPage />} />
        <Route path="orders-list" element={<OrdersList />} />
        <Route path="orders" element={<OrdersPage />} />
        <Route path="product-images-list" element={<ProductImagesList />} />
        <Route path="product-images" element={<ProductImagesPage />} />
        <Route path="product-questions-list" element={<ProductQuestionsList />} />
        <Route path="product-questions" element={<ProductQuestionsPage />} />
        <Route path="product-review-images-list" element={<ProductReviewImagesList />} />
        <Route path="product-review-images" element={<ProductReviewImagesPage />} />
        <Route path="product-reviews-list" element={<ProductReviewsList />} />
        <Route path="product-reviews" element={<ProductReviewsPage />} />
        <Route path="product-specifications-list" element={<ProductSpecificationsList />} />
        <Route path="product-specifications" element={<ProductSpecificationsPage />} />
        <Route path="product-tags-list" element={<ProductTagsList />} />
        <Route path="product-tags" element={<ProductTagsPage />} />
        <Route path="product-varient-options-list" element={<ProductVarientOptionsList />} />
        <Route path="product-varient-options" element={<ProductVarientOptionsPage />} />
        <Route path="product-varients-list" element={<ProductVarientsList />} />
        <Route path="product-varients" element={<ProductVarientsPage />} />
        <Route path="products-list" element={<ProductsList />} />
        <Route path="products" element={<ProductsPage />} />
        <Route path="states-list" element={<StatesList />} />
        <Route path="states" element={<Navigate to="/states-list" replace />} />
        <Route path="vendors-list" element={<VendorsList />} />
        <Route path="vendors" element={<VendorsPage />} />
        <Route path="wallet-transactions-list" element={<WalletTransactionsList />} />
        <Route path="wallet-transactions" element={<WalletTransactionsPage />} />
        <Route path="wishlists-list" element={<WishlistsList />} />
        <Route path="company-settings" element={<CompanySettingsPage />} />
        <Route path="my-profile" element={<MyProfilePage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
